<template>
  <div class="warrantyStatement-wrap">
   <div class="list-wrap">
    <div v-for="item in securityList" :key="item.id" class="item">
      <img :src="item.icon" alt="">
      <div class="text">
        <div class="name">{{item.title}}</div>
        <div class="desc">{{item.desc}}</div>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import { securityList } from '@/utils/const'
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  name: "WarrantyStatement",
  data() {
    return {
        securityList,
    };
  },
  methods: {},
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
};
</script>

<style scoped lang="scss">
.warrantyStatement-wrap {
  padding-top: 6px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 12px;
}
.title{
  display: flex;
  flex-direction: column;
  align-items: center;
  .title-text{
    font-size: 16px;
    color: #333;
  }
  .border-bg{
    height: 5px;
  }
}
.list-wrap {
  display: flex;
  justify-content: space-around;
}
.item {
  display: flex;
  margin-top: 14px;
  align-items: center;
  flex: 1;
  justify-content: center;
  flex-direction: column;
}
.item img {
  width: 46px;
  height: 46px;
}
.item .text {
  margin-top: 10px;
  text-align: center;
}
.item .text .name {
  font-size: 14px;
}
.item .text .desc {
  font-size: 12px;
  color: #999;
}
</style>
